export enum RatingScaleMode {
  Select = 'select',
  Edit = 'edit',
}
